import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

const PRESERVE = ['system'];

/**
 * 验证变量名规则指令
 * variable name rule validator in project management
 */
@Directive({
    /* eslint-disable @angular-eslint/directive-selector */
    selector: '[validateVariableName]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: VariableNameValidatorDirective,
            multi: true
        }
    ]
})
export class VariableNameValidatorDirective implements Validator {
    validate(c: AbstractControl): ValidationErrors | null {
        const VARIABLE_NAME_REGEXP = /^[a-zA-Z\u4e00-\u9fa5][a-zA-Z0-9\u4e00-\u9fa5_]*$/gm;
        const value = c.value;
        if (value === '' || value === null || value === undefined) {
            return null;
        } else if (value.trim() === '') {
            return null;
        } else if (!VARIABLE_NAME_REGEXP.test(value)) {
            return {
                validateVariableName: true
            };
        } else if (PRESERVE.includes((value as string).toLowerCase())) {
            return {
                includePreservedWords: true
            };
        } else {
            return null;
        }
    }
}
